"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.SimpleStore = undefined;

var _WebRTC = require("./WebRTC");

var _WebRTC2 = _interopRequireDefault(_WebRTC);

var _Channel = require("./Channel");

var _Channel2 = _interopRequireDefault(_Channel);

var _MultiChannel = require("./MultiChannel");

var _MultiChannel2 = _interopRequireDefault(_MultiChannel);

var _SimpleStore = require("./stores/SimpleStore");

var _SimpleStore2 = _interopRequireDefault(_SimpleStore);

var _retry = require("./helpers/retry");

var _retry2 = _interopRequireDefault(_retry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var CHANNEL2_SUFFIX = "-2";
var config = {
	store: null,
	iceServers: [{ urls: "stun:stun.l.google.com:19302" }]
};
var webrtc = new _WebRTC2.default(config);

exports.SimpleStore = _SimpleStore2.default;
exports.default = {
	createChannel: function () {
		var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
			var _this = this;

			var channel1, channel;
			return regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_context2.next = 2;
							return this.createSingleChannel();

						case 2:
							channel1 = _context2.sent;
							channel = new _MultiChannel2.default(channel1);


							(0, _retry2.default)(channel, "$waitChannel2", _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
								var channel2;
								return regeneratorRuntime.wrap(function _callee$(_context) {
									while (1) {
										switch (_context.prev = _context.next) {
											case 0:
												_context.next = 2;
												return _this.joinSingleChannel(channel.token + CHANNEL2_SUFFIX);

											case 2:
												channel2 = _context.sent;

												channel.connect(channel2);

											case 4:
											case "end":
												return _context.stop();
										}
									}
								}, _callee, _this);
							})));

							return _context2.abrupt("return", channel);

						case 6:
						case "end":
							return _context2.stop();
					}
				}
			}, _callee2, this);
		}));

		function createChannel() {
			return _ref.apply(this, arguments);
		}

		return createChannel;
	}(),
	joinChannel: function () {
		var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(token) {
			var channel1, channel2;
			return regeneratorRuntime.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							_context3.next = 2;
							return this.joinSingleChannel(token);

						case 2:
							channel1 = _context3.sent;
							_context3.next = 5;
							return this.createSingleChannel(token + CHANNEL2_SUFFIX);

						case 5:
							channel2 = _context3.sent;
							return _context3.abrupt("return", new _MultiChannel2.default(channel1, channel2));

						case 7:
						case "end":
							return _context3.stop();
					}
				}
			}, _callee3, this);
		}));

		function joinChannel(_x) {
			return _ref3.apply(this, arguments);
		}

		return joinChannel;
	}(),
	createSingleChannel: function () {
		var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
			var channel, _ref5, connection, dataChannel;

			return regeneratorRuntime.wrap(function _callee4$(_context4) {
				while (1) {
					switch (_context4.prev = _context4.next) {
						case 0:
							channel = new _Channel2.default(id);
							_context4.next = 3;
							return webrtc.createConnectionWithOffer();

						case 3:
							_ref5 = _context4.sent;
							connection = _ref5.connection;
							dataChannel = _ref5.dataChannel;


							webrtc.setConnectHandler(connection, dataChannel, channel);
							webrtc.setDisconnectHandler(connection, channel);
							webrtc.setWaitHandler(connection, channel);

							_context4.next = 11;
							return webrtc.saveOffer(connection, channel);

						case 11:
							return _context4.abrupt("return", channel);

						case 12:
						case "end":
							return _context4.stop();
					}
				}
			}, _callee4, this);
		}));

		function createSingleChannel(_x2) {
			return _ref4.apply(this, arguments);
		}

		return createSingleChannel;
	}(),
	joinSingleChannel: function () {
		var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(token) {
			var channel, offer, connection;
			return regeneratorRuntime.wrap(function _callee5$(_context5) {
				while (1) {
					switch (_context5.prev = _context5.next) {
						case 0:
							channel = new _Channel2.default(token);
							_context5.next = 3;
							return webrtc.getOffer(channel);

						case 3:
							offer = _context5.sent;
							_context5.next = 6;
							return webrtc.createConnectionWithAnswer(offer);

						case 6:
							connection = _context5.sent;
							_context5.next = 9;
							return webrtc.saveAnswer(connection, channel);

						case 9:

							connection.ondatachannel = function (_ref7) {
								var dataChannel = _ref7.channel;

								webrtc.setConnectHandler(connection, dataChannel, channel);
							};
							webrtc.setDisconnectHandler(connection, channel);

							return _context5.abrupt("return", channel);

						case 12:
						case "end":
							return _context5.stop();
					}
				}
			}, _callee5, this);
		}));

		function joinSingleChannel(_x3) {
			return _ref6.apply(this, arguments);
		}

		return joinSingleChannel;
	}(),
	setStore: function setStore(newStore) {
		config.store = newStore;
	},
	setIceServers: function setIceServers(newIceServers) {
		config.iceServers = newIceServers;
	}
};